exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addNewAdminModal .inputContainer{display:flex;flex-direction:row;margin-bottom:1em}.addNewAdminModal .inputContainer .inputLabel{width:40%;font-weight:700;align-self:center}.addNewAdminModal .inputContainer .Select,.addNewAdminModal .inputContainer input{width:60%;margin:0}.addNewAdminModal .inputContainer.childInput .inputLabel{margin-left:2%;width:40%;font-weight:unset;align-self:center}.addNewAdminModal .inputContainer.childInput .Select,.addNewAdminModal .inputContainer.childInput input{width:58%;margin:0}.addNewAdminModal .inputContainer.extraBottomMargin{margin-bottom:1.5em}.addNewAdminModal .inputContainer input[type=checkbox]{width:fit-content;border:none;box-shadow:none;margin-left:.5em}.addNewAdminModal .btnContainer{width:100%;text-align:center;padding:.5em 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/add_new_admin_modal.scss
// module id = 818
// module chunks = 0